import styled from "styled-components";

export const Entries = styled.div.attrs({ className: "Entries" })`
  display: grid;
  grid-template-columns: repeat(var(--cols), 1fr);
  gap: 24px;
`;
